<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1694_236)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2.12658 12C2.12658 6.54706 6.54706 2.12658 12 2.12658C17.4529 2.12658 21.8734 6.54706 21.8734 12C21.8734 17.4529 17.4529 21.8734 12 21.8734C6.54706 21.8734 2.12658 17.4529 2.12658 12ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM8.32281 6.07996C8.52213 5.96874 8.76611 5.97386 8.96057 6.09336L17.7001 11.464C17.8865 11.5785 18 11.7814 18 12C18 12.2186 17.8865 12.4215 17.7001 12.536L8.96057 17.9066C8.76611 18.0261 8.52213 18.0313 8.32281 17.92C8.12349 17.8088 8 17.5986 8 17.3706V6.62937C8 6.40136 8.12349 6.19118 8.32281 6.07996Z" fill="#5B6770"/>
</g>
<defs>
<clipPath id="clip0_1694_236">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
